$(document).ready(function () {
  

   if($('.select__select').length)
   {
     $(".productView-action .product-form__submit").addClass("blinix-disabled");
   } 

  
  $(".select__select").on('change', function() {
        if($(this).find('option:selected').index() == 0)
        {  
           $(".productView-action .product-form__submit").addClass("blinix-disabled");
        }else{
         
            $(".productView-action .product-form__submit").removeClass("blinix-disabled");
        }
  });

    var heightBox = 0;

    $(
        ".blinix-homepage-categories .blinix-row .blinix-column .collection-link"
    ).each(function () {
        if ($(this).height() > heightBox) {
            heightBox = $(this).height();
        }
    });

    $(
        ".blinix-homepage-categories .blinix-row .blinix-column .collection-link"
    ).height(heightBox);

    // Show the first tab and hide the rest
    $("#blinix-product-tabs-nav li:first-child").addClass("active");
    $(".tab-content").hide();
    $(".tab-content:first").show();

    // Click function
    $("#blinix-product-tabs-nav li").click(function () {
        $("#blinix-product-tabs-nav li").removeClass("active");
        $(this).addClass("active");
        $(".tab-content").hide();

        var activeTab = $(this).find("a").attr("href");
        $(activeTab).fadeIn();
        return false;
    });


    $(".blinix-mobile-warpper .blinix-row .blinix-column .blinix-hambuger").click(function () {
        $("#navigation-mobile").addClass("blinix_open-menu");
    });

    $("#navigation-mobile .halo-sidebar-close").click(function () {
        $("#navigation-mobile").removeClass("blinix_open-menu");
    });

    $(window).on("load", function () {
        const wishlistList = localStorage.getItem('wishlistItem') ? JSON.parse(localStorage.getItem('wishlistItem')) : [];
        $("#wish-wrap-cont").find("p.empty").text("You have " + wishlistList.length + " items in your wishlist.");
        //alert(wishlistList);
      
      
                                   
    });

    $('img').each(function() {
    var blinix = $(this).attr("alt")
        $(this).attr("title",blinix) 
    });
                
  
});


